import { render, staticRenderFns } from "./ThanksPage.vue?vue&type=template&id=389b1378&scoped=true&"
import script from "./ThanksPage.vue?vue&type=script&lang=js&"
export * from "./ThanksPage.vue?vue&type=script&lang=js&"
import style0 from "./ThanksPage.vue?vue&type=style&index=0&id=389b1378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b1378",
  null
  
)

export default component.exports